export default "__VITE_ASSET__Ba_oj8bI__";